import { ALL_STORES, getStore, putStore } from './stores-repository'
import { AppStore } from './app-store'
import { RoutingStore } from './routing-store'
import { DialogStore } from './dialog-store'
import { SnackbarStore } from './snackbar-store'
import { RegistrationStore } from './registration-store'
import { SetCaptchaStore } from './set-captcha-store'

export const createStore = (): {[storeName: string]: any} => {
    putStore(RoutingStore.storeName, new RoutingStore())
    putStore(SnackbarStore.storeName, new SnackbarStore())
    putStore(DialogStore.storeName, new DialogStore())
    putStore(AppStore.storeName, new AppStore())
    putStore(RegistrationStore.storeName, new RegistrationStore())
    putStore(SetCaptchaStore.storeName, new SetCaptchaStore())

    let store: any = {}
    ALL_STORES.forEach(storeName => {
        store[storeName] = getStore(storeName)
    })
    return store
}
